export const List = [
  {
    id: 1,
    img: 'https://cdn.dribbble.com/users/1319260/screenshots/16329726/media/c3f00d832cdeb482cba52a6a473d88a0.png?compress=1&resize=400x300',
    title: 'Take Me To Your Heart',
    desc: 'Johan Bejerholm',
    view: 3,
    body: `Whenever you need me， I'll be here。 Whenever you're in
  trouble， I'm always near。Whenever you feel alone， and you
  think everyone has given up。。。Reach out for me， and I will
  give you my everlasting love。`,
  },
  {
    id: 2,
    img: 'https://cdn.dribbble.com/users/4335179/screenshots/16323332/media/700459108009c77d83e8a75a891834e9.png?compress=1&resize=400x300',
    title: 'Only Love',
    desc: 'Johan Bejerholm',
    view: 2,
    body: `I just wish someday and somehow，We can be back together， Together we'll stay，Always and forever。`,
  },
  {
    id: 3,
    img: 'https://cdn.dribbble.com/users/3812993/screenshots/16326952/media/93cfe22526e7b21e6f38287fc936e708.png?compress=1&resize=400x300',
    title: 'That Girl',
    desc: 'Johan Bejerholm',
    view: 23,
    body: `Thoughts of you dance through my mind。 Knowing， it is just a matter of time。Wondering。。。 will u ever be mine?You are in my dreams， night。。。 and sometimes。。。 day。The thoughts seem to never fade away。 Corwin Corey Amber`,
  },
  {
    id: 4,
    img: 'https://cdn.dribbble.com/users/4205502/screenshots/16291726/media/1abf2a786cc29650983d48e72cab2d79.png?compress=1&resize=400x300',
    title: 'LIKE I WOULD',
    desc: 'Johan Bejerholm',
    view: 12,
    body: `I have searched a thousand years，And I have cried a thousand tears。I found everything I need，You are everything to me。 Barry Fitzpatrick`,
  },
  {
    id: 5,
    img: 'https://cdn.dribbble.com/users/702789/screenshots/16325312/media/4dec7e6269aa7418e800a1d3c03e9f99.png?compress=1&resize=400x300',
    title: 'You Are Not Alone',
    desc: 'Johan Bejerholm',
    view: 23,
    body: `Her gesture， motion， and her smiles，Her wit， her voice my heart beguiles，Beguiles my heart， I know not why，And yet， I'll love her till I die。 Thomas Ford`,
  },
  {
    id: 6,
    img: 'https://cdn.dribbble.com/users/32512/screenshots/16147049/media/9eaf445ca1b3abacada7c9f4871f980c.png?compress=1&resize=400x300',
    title: 'Free loop',
    desc: 'Johan Bejerholm',
    view: 36,
    body: `You make me feel so happy;Whenever I'm with you。You make me feel so special--This love is too good to be true。 Rosemary Anne Nash`,
  },
  {
    id: 7,
    img: 'https://cdn.dribbble.com/users/19950/screenshots/16329008/media/9825dd2d17a7941ef98fdb2319c9ea6b.jpeg?compress=1&resize=800x600',
    title: 'Trouble is a friend',
    desc: 'Johan Bejerholm',
    view: 23,
    body: `　If you were a teardrop，In my eye，For fear of losing you，I would never cry。And if the golden sun，Should cease to shine its light，Just one smile from you，Would make my whole world bright。 Hannah Jo Kee`,
  },
  {
    id: 8,
    img: 'https://cdn.dribbble.com/users/2598997/screenshots/16326547/media/db44f8eb3cebc789085a78971c647b8e.png?compress=1&resize=400x300',
    title: 'Yesterday once more',
    desc: 'Johan Bejerholm',
    view: 269,
    body: `Since the first time I saw you，I felt something inside，I don't know if it's love at first sight，I do know I really like you a lot。 Tanya C Medeiros`,
  },
  {
    id: 9,
    img: 'https://cdn.dribbble.com/users/3281732/screenshots/16318071/media/2dd5358672e6637b1ec7fb06e850c1c9.jpg?compress=1&resize=400x300',
    title: 'Angel',
    desc: 'Johan Bejerholm',
    view: 157,
    body: `There is a lady sweet and kind， Was never a face so pleased my mind;I did but see her passing by， And yet， I'll love her till I die。 Thomas Ford`,
  },
  {
    id: 10,
    img: 'https://cdn.dribbble.com/users/1126935/screenshots/16325356/media/0d45ed1a4ca2cd8274d2aab9990e29ba.png?compress=1&resize=400x300',
    title: 'thesoundofsilent',
    desc: 'Johan Bejerholm',
    view: 698,
    body: `When I wake up in the morning，You are all I see;When I think about you，And how happy you make me。You're everything I wanted;You're everything I need;I look at you and know;That you are all to me。 Barry Fitzpatrick`,
  },
  {
    id: 11,
    img: 'https://cdn.dribbble.com/users/730703/screenshots/16321137/media/68db2cf9022123e07016b89dbe69546e.jpg?compress=1&resize=800x600',
    title: 'prayer',
    desc: 'Johan Bejerholm',
    view: 36,
    body: `If you were a teardrop;In my eye，For fear of losing you，I would never cry。And if the golden sun，Should cease to shine its light，Just one smile from you，Would make my whole world bright。 Hannah Jo Keen`,
  },
];
